import React from "react";

import styles from "./ApplicationDetail.module.scss";
import {faArrowAltCircleLeft} from "@fortawesome/free-regular-svg-icons/faArrowAltCircleLeft";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {Reviews} from "./Reviews";
import {useNavigate} from "react-router-dom";

function ApplicationDetail({application = {}}) {
    const PLAY_STORE = 'play_store';
    const APP_STORE = 'app_store';

    const navigate = useNavigate();

    const hasPlayStoreData = application.stores?.some(store => store.storeType === PLAY_STORE);
    const hasAppStoreData = application.stores?.some(store => store.storeType === APP_STORE);

    const DEFAULT_STORE = hasPlayStoreData ? PLAY_STORE : APP_STORE;
    const [selectedStore, setSelectedStore] = React.useState(DEFAULT_STORE);

    const storeData = application.stores?.find(store => store.storeType === selectedStore) || {};
    const storeImages = storeData.images || [];
    const storeIcon = storeImages.find(image => image.imageType === 'icon' && image.language === storeData.defaultLanguage)?.url;

    const storeListings = storeData.listings?.sort((a, b) => {
        if (a.language === storeData.defaultLanguage) {
            return -1;
        }
        if (b.language === storeData.defaultLanguage) {
            return 1;
        }
        return 0;
    }) || [];
    const storeDefaultListing = storeListings.find(listing => listing.language === storeData.defaultLanguage) || {};

    // const storePhoneScreenshots = storeImages.filter(image => image.imageType === 'phoneScreenshots' && image.language === storeData.defaultLanguage) || [];

    function handleStoreSelection(storeType) {
        if (storeType === selectedStore) {
            return;
        }

        if (storeType === PLAY_STORE && !hasPlayStoreData) {
            return;
        }

        if (storeType === APP_STORE && !hasAppStoreData) {
            return;
        }

        setSelectedStore(storeType);
    }

    return (
        <div className={styles.container}>
            {/* Header Bar: back icon left, switcher centered */}
            <div className={styles.headerBar}>
                <div className={styles.headerBack}>
                    <FontAwesomeIcon
                        onClick={() => navigate("/app/applications")}
                        className={styles.backIcon}
                        icon={faArrowAltCircleLeft} size="xl"/>
                </div>
                <div className={styles.headerSwitcher}>
                    <nav className={styles.switcher}>
                        <div className={styles.storeTypes}>
                            <button
                                className={`${styles.switchButton} ${selectedStore === PLAY_STORE ? styles.active : ''} ${!hasPlayStoreData ? styles.disabled : ''}`}
                                onClick={() => handleStoreSelection(PLAY_STORE)}
                                disabled={!hasPlayStoreData}
                            >
                                Play Store
                            </button>
                            <button
                                className={`${styles.switchButton} ${selectedStore === APP_STORE ? styles.active : ''} ${!hasAppStoreData ? styles.disabled : ''}`}
                                onClick={() => handleStoreSelection(APP_STORE)}
                                disabled={!hasAppStoreData}
                            >
                                App Store
                            </button>
                        </div>
                    </nav>
                </div>
            </div>

            <main className={styles.mainContent}>
                {/* App Icon and Info */}
                <section className={styles.leftPanel}>
                    <img src={storeIcon} alt="icon" className={styles.appIcon}/>
                    <h2 className={styles.title}>{storeDefaultListing.title}</h2>
                    <p className={styles.category}>{application.category}</p>
                </section>

                {/* App Details */}
                <section className={styles.rightPanel}>
                    <div className={styles.aboutBox}>
                        <h3 className={styles.aboutTitle}>About Application</h3>
                        <p className={styles.shortDescription}>{storeDefaultListing.shortDescription}</p>
                        <p className={styles.fullDescription}>{storeDefaultListing.fullDescription}</p>
                    </div>
                </section>
            </main>

            {/* Reviews Section */}
            <section className={styles.reviewsSection}>
                <Reviews application={application}/>
            </section>
        </div>
    );
}

export {ApplicationDetail};
